module.exports = __webpack_public_path__ + "email_teal.307320ad0b9ee8f18f61.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/email_teal.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/email_teal.svg
// module chunks = styles